import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './BannerData.css'
import NewBanner from '../NewBanner/NewBanner';
export default function BannerData() {
    const [banners, setBanners] = useState([]);
    const [editandoId, setEditandoId] = useState(null);
    const [textoEditado, setTextoEditado] = useState('');
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        cargarBanners();

    }, []);
    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setBanners(data.banner || []);
                console.log(data.banner)
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };
    const eliminarBanner = (idBanner) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/bannerDelete.php?idBanner=${idBanner}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarBanners();
                    })
                    .catch(error => {
                        console.error('Error al eliminar la Producto:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const iniciarEdicionTexto = (item) => {
        setEditandoId(item.idBanner);
        setTextoEditado(item.texto || '');
    };

    const cancelarEdicionTexto = () => {
        setEditandoId(null);
        setTextoEditado('');
    };

    const guardarTexto = (idBanner) => {
        setGuardando(true);
        fetch(`${baseURL}/bannerTextoPut.php?idBanner=${idBanner}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ texto: textoEditado }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    toast.error(data.error);
                    setGuardando(false);
                    return;
                }
                setBanners(prev => prev.map(b =>
                    b.idBanner === idBanner ? { ...b, texto: data.texto } : b
                ));
                toast.success('Texto actualizado.');
                setEditandoId(null);
                setGuardando(false);
            })
            .catch(error => {
                console.error('Error al actualizar el texto del banner:', error);
                toast.error('Error al actualizar el texto.');
                setGuardando(false);
            });
    };

    return (
        <div className='BannerContainer'>
            <NewBanner />
            <div className='BannerWrap'>
                {
                    banners.map(item => (
                        <div key={item.idBanner} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className='cardBanner'>
                                {item.tipo === 'video' ? (
                                    <video src={item.imagen} muted controls />
                                ) : (
                                    <img src={item.imagen} alt="banner" />
                                )}
                                <button className='btnBannerDelete' onClick={() => eliminarBanner(item.idBanner)}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>
                                <button className='btnBannerEdit' onClick={() => iniciarEdicionTexto(item)} title='Editar texto del banner'>
                                    <FontAwesomeIcon icon={faEdit} />
                                </button>
                            </div>
                            {item.isMobile === 1 &&(
                                <span>Imagen móvil</span>
                            )}
                            {editandoId === item.idBanner ? (
                                <div className='bannerTextoEdit'>
                                    <input
                                        type='text'
                                        value={textoEditado}
                                        onChange={(e) => setTextoEditado(e.target.value)}
                                        placeholder='Texto del banner'
                                        autoFocus
                                    />
                                    <div className='bannerTextoEditBtns'>
                                        <button onClick={() => guardarTexto(item.idBanner)} disabled={guardando} className='btnPost'>
                                            {guardando ? 'Guardando...' : 'Guardar'}
                                        </button>
                                        <button onClick={cancelarEdicionTexto} disabled={guardando} className='btnCancelar'>
                                            Cancelar
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                item.texto && (
                                    <span className='bannerTextoPreview'>"{item.texto}"</span>
                                )
                            )}
                        </div>
                    ))
                }

            </div>

        </div>
    )
}
